<template>
 <common-dialog
      ref="dialog"
      width="750px"
      :show-save-button="false"
      unit="审批日志"
      id-key="LogId"
      :data="data"
      form-label-width="95px"
      :form-rules="rules"
      :save-func="()=>{}"
      :get-data-func="api.list"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
    >
    <el-table border size="mini" :data="tableData" style="width: 100%">
            <el-table-column prop="EmpName" label="操作人" width="75px"/>
            <el-table-column prop="AddTime" label="操作时间"  width="150px"/>
            <el-table-column prop="OperType" label="操作" width="100px"/>
            <el-table-column prop="Remark" label="备注"/>
            <slot name="column"></slot>
    </el-table>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" size="small" @click="close">关 闭</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import editDialogMixin from "@/mixins/editDialog";
import list from "@/components/common/list";
export default {
  components: {
    commonDialog,
    list
  },
  mixins: [editDialogMixin],

  data() {
    return {
      api: require("@/api/sy/log").default,
      data: {

      },
      main: [],
      ExamNames: "",
      ExamIds: [],
      tableData: [],
      type: null,
      rules:{},
      params: {
         RecordId:0
      },
      location:location
    };
  },
  methods: {
    onOpened(data){
        
    },
    onCreateOpened(row) {
    },

    onEditOpened(type) {
      this.api.list(type).then(res => {
        if(res.Code==0){
            this.tableData=res.Data
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  margin-bottom: 10px;
  .info {
    display: inline-block;
    margin-right: 40px;
  }
}
.examSearch {
  padding-top: 10px;
  margin-bottom: 20px;
}
.detailsTable {
  margin: 20px 0;
}
.examInp {
  width: calc(100% - 70px);
  /deep/ .el-input__inner {
    width: 100%;
  }
}
</style>
